import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AccountStatusState } from './shared-constants';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AccountStatusService {
	constructor(
		private db: SpaqFireDb,
		private auth: AngularFireAuth
	) {}

	hydrate() {
		return this.auth.user.pipe(switchMap(u => (u ? this.db.userAccountStatus$<AccountStatusState>(u.uid) : EMPTY)));
	}

	update(status: any) {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => (u ? this.db.updateUserAccountStatus(u.uid, status) : EMPTY))
		);
	}
}
